export const environment = {
  production: false,
  API_URL: '/api',
  STRIPE:
    'pk_test_51GvN55IqziYJrkKS25DrF9bp1UHSVRtTHmXZYbBPJxtSQJv8KGZ5JFk1J7yxM1mPpnBLOQu3fU7wfNBCId0PNM1c00ezplO9sc',
  GOOGLE_MAPS_API_KEY: 'AIzaSyC8fcQBPlvaYSJfoEUfPbda7BQV7gDynQc',
};
